/**
 * Which pages get the site's own header (with Sign in) and footer on desktop.
 *
 * The sign-in pages draw their own. They are matched on the whole first path
 * segment: a substring test of a joined list once hid the header, and so the
 * only desktop way to sign in, on every /us page ("us" is inside
 * "verify-user"), and on any store whose code hides in those words.
 */
export const AUTH_PAGES = ["login", "verify-user", "signup"];

const firstSegment = (pathname) => String(pathname || "").split("/")[1] || "";

export const drawsOwnHeader = (pathname) => AUTH_PAGES.includes(firstSegment(pathname));

/** India's home (/, /marketplace) or a store's home (/us): the landing header. */
export const isLandingPath = (pathname) => {
  const first = firstSegment(pathname);
  return first === "" || first === "marketplace" || /^\/[a-z]{2}\/?$/i.test(String(pathname || ""));
};
